export default {
  product:{
    tabName1:"按产品",
    tabName2:"按场景",
    tabName3:"按行业",
  },
  production:{
    chanpinxinghao: '产品名称',
    placeholder: '请输入产品名称',
    chanpinleixing: '产品类型',
    placeholder1: '请选择产品类型',
  },
  home:{
    news:"新媒体",
    tip1:"请输入关键词",
    tip2:"开始日期",
    tip3:"结束日期",
    tip4:"浏览量",
    
    title:"深圳市航鸿达科技有限公司官网",
    home:"首页",
    product:"产品中心",
    sulotion:"应用",
    us:"关于我们",
    bo:"论坛",
    search:"搜索",
    yingwen:"英文",
    zhongwen:"中文",
    denglu:"登录",
    gengduo:"阅读更多",
    xhanp:"产品详情",
    banner:"轮播图",
    lx:"联系我们",
    fa:"方案详情",
    xw:"新闻详情",
    noResult:"没有找到结果。 尝试不同的搜索?",
    resultNum:"我们为您的搜索找到了0项结果",
    tip:'定制',
    case:"案例",
    casedetail:"案例详情",
    more:"加载更多"
  },
  my:{
    cptp:"产品图片",
    cpmz:"产品名字",
    sl:"数量",
    placeholder:'请输入内容',
    placeholder1:'请输入名字',
    placeholder2:'请输入邮箱',
    placeholder3:'请输入公司名字',
    placeholder4:'请输入联系电话',
    placeholder5:'请输入留言',
    placeholder6:'请输入正确的邮箱地址',
    mz:"名字",
    email:"邮箱",
    gsmz:"公司名字",
    dh:"电话",
    ly:"留言",
    tj:"提交",
    tip:"提交成功",
    tai:"台",
    cpzx:"产品咨询",
    searchR:"搜索结果",
    pre:"上一篇",
    next:"下一篇",
    address:'© 深圳市航鸿达科技有限公司 版权所有 2016-2021',
    currentL:"当前位置",
    tip:'粤ICP备17042227号-7',
    tip1:'网站地图'
  },
  media:{
    tip1:"请输入方案详情",
    tip2:"请输入总标题",
    tip3:"请输入下级标题",
    tip4:"方案背景",
    tip5:"请输入方案背景",
    tip6:"产品介绍",
    tip7:"标题",
    tip8:"请输入标题",
    tip9:"请选择产品名称",
    tip10:"请输入产品说明",
    tip11:"查看详情",
    tip12:"方案亮点",
    tip13:"请输入解决方案优点/突出点标题",
    tip14:"请输入解决方案优点/突出点文字说明",
    tip15:"产品推荐",
    tip16:"请上传方案详情顶部图片",
    tip17:"请输入总标题",
    tip18:"请输入下级标题",
    tip19:"请上传产品介绍图片",
    tip20:"请输入产品介绍标题",
    tip21:"请选择产品介绍的产品型号",
    tip22:"请选择产品介绍的产品名称",
    tip23:"请输入产品介绍的产品说明",
    tip24:"请完善方案亮点内容",
    tip25:"产品推荐至少填写一个",
    tip26:"产品推荐图片不能为空",
    tip27:"产品推荐名称不能为空",
    tip28:"产品介绍至少填写一个",


    tip29:"网站入口",
    tip30:"合作伙伴展示",
    tip31:"合作申请",
    tip32:"您的姓名",
    tip33:"您的电话",
    tip34:"邮箱地址",
    tip35:"公司名称",
    tip36:"请填写您的需求",
    tip37:"请输入您的姓名",
    tip38:"请输入您的电话",
    tip39:"请输入邮箱地址",
    tip40:"请输入公司名称",
    tip41:"立即提交",
    tip42:"提交成功",
    tip43:"只能输入数字",
    tip44:"邮箱格式不正确",
    tip45:"系统"
  }
}


// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js